import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactElement; redirectTo?: string }> = ({ children, redirectTo = '/login/' }) => {
	const { isAuthenticated, isInitializing } = useAuth();
	if (isInitializing) {
		return null;
	}
	if (!isAuthenticated) {
		return <Navigate to={redirectTo} replace />;
	}
	return children;
};

export default ProtectedRoute; 